import {v4 as uuidv4} from "uuid";
import EnterpriseComponent from "../../EnterpriseComponent";
import AxiosRestAPI from "../../../../util/AxiosRestAPI";
import {V1DocumentRevisionIDOCToArray} from "../../../../util/Payload";

class DocumentRevisionRDEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        // status = 'DRAFT', 'PENDING_CHANGE', 'SUBMITTED', 'IN_REVIEW', 'APPROVED', 'RELEASED', 'DEPRECATED', 'OBSOLETE', 'CANCELED', 'VOIDED'

        let QBE = {
            "PlatformMessage": {
                "-idoc": "v1.ObjectRevision-001",
                "-id": uuidv4(),
                "DocumentRevision": {
                    '_attributes': {
                        'limit': pageSize,
                        'sort': this.getFormattedSortSpecification(),
                        'offset': (page - 1) * pageSize
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "primary",
                                "Operator": "AND",
                                "Type": "QueryGroup",
                                "Membership": {
                                    "Member": [{
                                        "Type": "Attribute",
                                        "Name": "Status",
                                        "Value": "'DRAFT','RELEASED','PENDING_CHANGE','SUBMITTED','IN_REVIEW','APPROVED'",
                                        "Operator": "IN"
                                    }]
                                }
                            }
                        ]
                    }
                }
            }
        }
        let queryPayload = this.prepareQueryPayload();

        if (queryPayload.size > 0) {
            for (const [key, value] of queryPayload) {
                if (key.includes("_query")) continue;

                let operator = "EQUAL";
                if (queryPayload.get(key + "_query") !== undefined) {
                    operator = queryPayload.get(key + "_query")
                }
                QBE.PlatformMessage.DocumentRevision.QueryGroups.QueryGroup[0].Membership.Member.push({
                    "Type": "Attribute",
                    "Name": key,
                    "Value": value,
                    "Operator": operator
                })
            }
        }

        AxiosRestAPI({
            method: "GET",
            url: "t1/v1/document_revisions",
            json: true,
            params: {
                "QBE": btoa(JSON.stringify(QBE))
            },
            headers: {
                "visibility-mode": this.getVisibilityMode(),
                "visibility-value": this.getVisibilityValue(),
                "idoc-response": this.getIDOCResponse() ?? "v1.ObjectRevision-001",
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1DocumentRevisionIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };
}

export default DocumentRevisionRDEnterpriseComponent;